/* Template Name: Techwind - Saas & Software Landing Page Template
   Author: Shreethemes
   E-mail: support@shreethemes.in
   Created: May 2022
   Version: 1.1.0
   File Description: Main JS file of the template
*/
var Flickity = require('flickity');
require('flickity-imagesloaded');
window.Flickity = Flickity;
require('animate.css');
import SlimSelect from 'slim-select'
window.SlimSelect = SlimSelect;

// window.NiceSelect = require('nice-select2');
// new NiceSelect(document.getElementById("a-select"), {searchable: true});

/*********************************/
/*         INDEX                 */
/*================================
 *     01.  Loader               *
 *     02.  Toggle Menus         *
 *     03.  Active Menu          *
 *     04.  Clickable Menu       *
 *     05.  Back to top          *
 *     06.  Feather icon         *
 *     06.  DD Menu              *
 *     06.  Active Sidebar Menu  *
 *     07.  Contact us           *
 ================================*/


window.addEventListener('load', fn, false)

 //  window.onload = function loader() {
const fn = () => {
     // Preloader 
     console.log("this happens");
     if (document.getElementById('preloader')) {
         setTimeout(() => {
             document.getElementById('preloader').style.visibility = 'hidden';
             document.getElementById('preloader').style.opacity = '0';
         }, 350);
     }
     // Menus
     activateMenu();
 }
 
 //Menu
 /*********************/
 /* Toggle Menu */
 /*********************/
 const toggleMenu = () => {
     document.getElementById('isToggle').classList.toggle('open');
     var isOpen = document.getElementById('navigation')
     if (isOpen.style.display === "block") {
         isOpen.style.display = "none";
     } else {
         isOpen.style.display = "block";
     }
 };
 window.toggleMenu = toggleMenu;
 /*********************/
 /*    Menu Active    */
 /*********************/
 function getClosest(elem, selector) {
 
     // Element.matches() polyfill
     if (!Element.prototype.matches) {
         Element.prototype.matches =
             Element.prototype.matchesSelector ||
             Element.prototype.mozMatchesSelector ||
             Element.prototype.msMatchesSelector ||
             Element.prototype.oMatchesSelector ||
             Element.prototype.webkitMatchesSelector ||
             function (s) {
                 var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                     i = matches.length;
                 while (--i >= 0 && matches.item(i) !== this) {}
                 return i > -1;
             };
     }
 
     // Get the closest matching element
     for (; elem && elem !== document; elem = elem.parentNode) {
         if (elem.matches(selector)) return elem;
     }
     return null;
 
 };
 
 function activateMenu() {
     var menuItems = document.getElementsByClassName("sub-menu-item");
     if (menuItems) {
 
         var matchingMenuItem = null;
         for (var idx = 0; idx < menuItems.length; idx++) {
             if (menuItems[idx].href === window.location.href) {
                 matchingMenuItem = menuItems[idx];
             }
         }
 
         if (matchingMenuItem) {
             matchingMenuItem.classList.add('active');
             var immediateParent = getClosest(matchingMenuItem, 'li');
             if (immediateParent) {
                 immediateParent.classList.add('active');
             }
 
             var parent = getClosest(matchingMenuItem, '.parent-menu-item');
             if (parent) {
                 parent.classList.add('active');
                 var parentMenuitem = parent.querySelector('.menu-item');
                 if (parentMenuitem) {
                     parentMenuitem.classList.add('active');
                 }
                 var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                 if (parentOfParent) {
                     parentOfParent.classList.add('active');
                 }
             } else {
                 var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                 if (parentOfParent) {
                     parentOfParent.classList.add('active');
                 }
             }
         }
     }
 }
 /*********************/
 /*  Clickable manu   */
 /*********************/
 if (document.getElementById("navigation")) {
     var elements = document.getElementById("navigation").getElementsByTagName("p");
     for (var i = 0, len = elements.length; i < len; i++) {
         elements[i].onclick = function (elem) {
            //  if (elem.target.getAttribute("href") === "javascript:void(0)") {
                 var submenu = elem.target.nextElementSibling.nextElementSibling;
                 submenu.classList.toggle('open');
            //  }
         }
     }
 }
 /*********************/
 /*   Menu Sticky     */
 /*********************/
 function windowScroll() {
     const navbar = document.getElementById("topnav");
     if (navbar != null) {
         if (
             document.body.scrollTop >= 50 ||
             document.documentElement.scrollTop >= 50
         ) {
             navbar.classList.add("nav-sticky");
         } else {
             navbar.classList.remove("nav-sticky");
         }
     }
 }
 
 window.addEventListener('scroll', (ev) => {
     ev.preventDefault();
     windowScroll();
 })
 /*********************/
 /*    Back To TOp    */
 /*********************/
 
 window.onscroll = function () {
     scrollFunction();
 };
 
 function scrollFunction() {
     var mybutton = document.getElementById("back-to-top");
     if(mybutton!=null){
         if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
             mybutton.classList.add("block");
             mybutton.classList.remove("hidden");
         } else {
             mybutton.classList.add("hidden");
             mybutton.classList.remove("block");
         }
     }
 }
 
 function topFunction() {
     document.body.scrollTop = 0;
     document.documentElement.scrollTop = 0;
 }
 
 /*********************/
 /*  Active Sidebar   */
 /*********************/
 (function () {
     var current = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);;
     if (current === "") return;
     var menuItems = document.querySelectorAll('.sidebar-nav a');
     for (var i = 0, len = menuItems.length; i < len; i++) {
         if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
             menuItems[i].parentElement.className += " active";
         }
     }
 })();
 
 /*********************/
 /*   Feather Icons   */
 /*********************/
 feather.replace();
 
 /*********************/
 /*    DD Menu        */
 /*********************/
 var ddmenu = document.getElementsByClassName("dd-menu");
 for (var i = 0, len = ddmenu.length; i < len; i++) {
     ddmenu[i].onclick = function (elem) {
         elem.stopPropagation();
     }
 }
 
 /*********************/
 /*     Small Menu    */
 /*********************/
 try {
     var spy = new Gumshoe('#navmenu-nav a');
 } catch (err) {
 
 }
 
 /*********************/
 /* Dark & Light Mode */
 /*********************/
 try {
     function changeTheme(e){
         e.preventDefault()
         const htmlTag = document.getElementsByTagName("html")[0]
         
         if (htmlTag.className.includes("dark")) {
             htmlTag.className = 'light'
         } else {
             htmlTag.className = 'dark'
         }
     }
 
     const switcher = document.getElementById("theme-mode")
     switcher?.addEventListener("click" ,changeTheme )
     
     const chk = document.getElementById('chk');
 
     chk.addEventListener('change',changeTheme);
 } catch (err) {
     
 }
// Event delegation
const on = (selector, eventType, childSelector, eventHandler) => {
  const elements = document.querySelectorAll(selector);
  for (const element of elements) {
    element.addEventListener(eventType, (eventOnElement) => {
      if (eventOnElement.target.closest(childSelector)) {
        eventHandler(eventOnElement);
      }
    });
  }
};
  
// Open Collapse
const openCollapse = (collapse, callback) => {
  collapse.style.transitionProperty = "height, opacity";
  collapse.style.transitionDuration = "200ms";
  collapse.style.transitionTimingFunction = "ease-in-out";

  setTimeout(() => {
    collapse.style.height = collapse.scrollHeight + "px";
    collapse.style.opacity = 1;
  }, 100);

  collapse.addEventListener(
    "transitionend",
    () => {
      collapse.classList.add("open");

      collapse.style.removeProperty("height");
      collapse.style.removeProperty("opacity");

      collapse.style.removeProperty("transition-property");
      collapse.style.removeProperty("transition-duration");
      collapse.style.removeProperty("transition-timing-function");

      if (typeof callback === "function") callback();
    },
    { once: true }
  );
};
  
// Close Collapse
const closeCollapse = (collapse, callback) => {
  collapse.style.overflowY = "hidden";
  collapse.style.height = collapse.scrollHeight + "px";
  collapse.style.transitionProperty = "height, opacity";
  collapse.style.transitionDuration = "200ms";
  collapse.style.transitionTimingFunction = "ease-in-out";

  setTimeout(() => {
    collapse.style.height = 0;
    collapse.style.opacity = 0;
  }, 200);

  collapse.addEventListener(
    "transitionend",
    () => {
      collapse.classList.remove("open");

      collapse.style.removeProperty("overflow-y");
      collapse.style.removeProperty("height");
      collapse.style.removeProperty("opacity");

      collapse.style.removeProperty("transition-property");
      collapse.style.removeProperty("transition-duration");
      collapse.style.removeProperty("transition-timing-function");

      if (typeof callback === "function") callback();
    },
    { once: true }
  );
};
  
  // add collaspe and tabs here
  // Collapse
const collapse = () => {
  const selector = '[data-toggle="collapse"]';

  // Toggle Collapse
  const toggleCollapse = (collapseTrigger) => {
    collapseTrigger.classList.toggle("active");

    // Collapse
    const collapses = document.querySelectorAll(collapseTrigger.dataset.target);
    collapses.forEach((collapse) => {
      if (collapse.classList.contains("open")) {
        closeCollapse(collapse);
      } else {
        openCollapse(collapse);
      }
    });

    // Accordion
    const accordion = collapseTrigger.closest(".accordion");
    if (accordion) {
      const accordionTriggers = accordion.querySelectorAll(selector);
      accordionTriggers.forEach((accordionTrigger) => {
        if (accordionTrigger !== collapseTrigger) {
          accordionTrigger.classList.remove("active");
        }
      });

      const accordions = accordion.querySelectorAll(".collapseItem");
      accordions.forEach((accordion) => {
        if (accordion.classList.contains("open")) {
          closeCollapse(accordion);
        }
      });
    }
  };

  on("body", "click", selector, (event) => {
    const collapseTrigger = event.target.closest(selector);
    toggleCollapse(collapseTrigger);
  });
};

collapse();

// Tabs
const tabs = () => {
  let toggling = false;

  on("body", "click", '[data-toggle="tab"]', (event) => {
    const trigger = event.target.closest('[data-toggle="tab"]');

    const tabs = trigger.closest(".tabs");
    const activeTabTrigger = tabs.querySelector(".tab-nav .active");
    const activeTab = tabs.querySelector(".collapseItem.open");
    const targetedTab = tabs.querySelector(trigger.dataset.target);

    if (toggling) return;
    if (activeTabTrigger === trigger) return;

    // Trigger
    activeTabTrigger.classList.remove("active");
    trigger.classList.add("active");

    // Tab
    // Close
    toggling = true;

    closeCollapse(activeTab, () => {
      openCollapse(targetedTab, () => {
        toggling = false;
      });
    });
  });

  // Wizard (Previous/Next)
  on("body", "click", '[data-toggle="wizard"]', (event) => {
    const wizard = event.target.closest(".wizard");
    const direction = event.target.dataset.direction;
    const tabLinks = wizard.querySelectorAll(".nav-link");
    const activeLink = wizard.querySelector(".nav-link.active");

    let activeIndex = 0;

    tabLinks.forEach((link, index) => {
      if (link === activeLink) {
        activeIndex = index;
      }
    });

    switch (direction) {
      case "next":
        if (tabLinks[activeIndex + 1]) {
          tabLinks[activeIndex + 1].click();
        }
        break;
      case "previous":
        if (tabLinks[activeIndex - 1]) {
          tabLinks[activeIndex - 1].click();
        }
        break;
    }
  });
};

tabs();

//=========================================//
/*/*            07) Gallery filter js      */
//=========================================//

try {
  var Shuffle = window.Shuffle;

  class Demo {
      constructor(element) {
          if(element){
              this.element = element;
              this.shuffle = new Shuffle(element, {
                  itemSelector: '.picture-item',
                  sizer: element.querySelector('.my-sizer-element'),
              });

              // Log events.
              this.addShuffleEventListeners();
              this._activeFilters = [];
              this.addFilterButtons();
          }
      }

      /**
       * Shuffle uses the CustomEvent constructor to dispatch events. You can listen
       * for them like you normally would (with jQuery for example).
       */
      addShuffleEventListeners() {
          this.shuffle.on(Shuffle.EventType.LAYOUT, (data) => {
              console.log('layout. data:', data);
          });
          this.shuffle.on(Shuffle.EventType.REMOVED, (data) => {
              console.log('removed. data:', data);
          });
      }

      addFilterButtons() {
          const options = document.querySelector('.filter-options');
          if (!options) {
              return;
          }

          const filterButtons = Array.from(options.children);
          const onClick = this._handleFilterClick.bind(this);
          filterButtons.forEach((button) => {
              button.addEventListener('click', onClick, false);
          });
      }

      _handleFilterClick(evt) {
          const btn = evt.currentTarget;
          const isActive = btn.classList.contains('active');
          const btnGroup = btn.getAttribute('data-group');

          this._removeActiveClassFromChildren(btn.parentNode);

          let filterGroup;
          if (isActive) {
              btn.classList.remove('active');
              filterGroup = Shuffle.ALL_ITEMS;
          } else {
              btn.classList.add('active');
              filterGroup = btnGroup;
          }

          this.shuffle.filter(filterGroup);
      }

      _removeActiveClassFromChildren(parent) {
          const { children } = parent;
          for (let i = children.length - 1; i >= 0; i--) {
              children[i].classList.remove('active');
          }
      }
  }

  document.addEventListener('DOMContentLoaded', () => {
      window.demo = new Demo(document.getElementById('grid'));
  });
} catch (err) {

}

// Overlay
// Show
const showOverlay = (workspace) => {
  if (document.querySelector(".overlay")) return;

  document.body.classList.add("overlay-show");

  const overlay = document.createElement("div");
  if (workspace) {
    overlay.setAttribute("class", "overlay workspace");
  } else {
    overlay.setAttribute("class", "overlay");
  }

  document.body.appendChild(overlay);
  overlay.classList.add("active");
};
// AnimateCSS
const animateCSS = (element, animation, prefix = "animate__") => {
  return new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const node = element;

    node.classList.add(`${prefix}animated`, `${prefix}faster`, animationName);

    const handleAnimationEnd = (event) => {
      event.stopPropagation();
      node.classList.remove(
        `${prefix}animated`,
        `${prefix}faster`,
        animationName
      );
      resolve("Animation Ended.");
    };

    node.addEventListener("animationend", handleAnimationEnd, { once: true });
  });
};
// Hide
const hideOverlay = () => {
  var overlayToRemove = document.querySelector(".overlay");

  if (!overlayToRemove) return;

  document.body.classList.remove("overlay-show");

  overlayToRemove.classList.remove("active");
  document.body.removeChild(overlayToRemove);
};
// Modal
const modal = () => {
  // Show
  const showModal = (modal) => {
    showOverlay();
    modal.classList.add("active");
    const animation = modal.dataset.animations.split(", ")[0];
    const modalContent = modal.querySelector(".modal-content");
    animateCSS(modalContent, animation);

    modal.addEventListener("click", (event) => {
      if (modal.dataset.staticBackdrop !== undefined) return;
      if (modal !== event.target) return;
      closeModal(modal);
    });
  };

  on("body", "click", '[data-toggle="modal"]', (event) => {
    const modal = document.querySelector(event.target.dataset.target);
    showModal(modal);
  });

  // Close
  const closeModal = (modal) => {
    hideOverlay();
    const animation = modal.dataset.animations.split(", ")[1];
    const modalContent = modal.querySelector(".modal-content");
    animateCSS(modalContent, animation).then(() => {
      modal.classList.remove("active");
    });
  };

  on(".modal", "click", '[data-dismiss="modal"]', (event) => {
    const modal = event.target.closest(".modal");
    closeModal(modal);
  });
};

modal();

function hideModal(modal){
  hideOverlay();
  const animation = modal.dataset.animations.split(", ")[1];
  const modalContent = modal.querySelector(".modal-content");
  animateCSS(modalContent, animation).then(() => {
  modal.classList.remove("active");
  });
}